module.exports = {
      id: "story-play-usage",
      viewBox: "0 0 35 35",
      url: __webpack_public_path__ + "svg-sprite.svg#story-play",
      toString: function () {
        return this.url;
      }
    }